
import { Vue, Component, Prop } from "vue-property-decorator";
import Page from "@/components/Page.vue";

@Component({ components: { Page } })
export default class App extends Vue {
  @Prop()
  id!: string;

  nav = new Map([
    ["Stammdaten", "Stammdaten"],
    ["Analysen", "Analysen"],
    ["Zeitreihen", "Zeitreihen"],
    ["Download", "Download"]
  ]);
}
